(function($, window, document) {

    $(function() {

        initDropdowns();

        var observerError = new MutationObserver(function(mutationsList) {
            mutationsList.forEach(function(mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function(node) {
                        if (node.nodeType === 1) { // Vérifie si le nœud est un élément (nodeType 1)
                            var element = $(node);
                            if (element.is('span.error') && element.siblings('input').hasClass('sinistersGlobalError')) {
                                element.prepend('<div class="alert-picto"></div>');
                            }
                        }
                    });
                }
            });
        });
        
        // Configurer l'observation pour surveiller les ajouts d'éléments dans le body
        var config = { childList: true, subtree: true };
        
        // Commencer l'observation sur le body
        observerError.observe(document.body, config);

        $('div.customized-error').each(function(){
            if (!$(this).attr('id')) {
                $(this).find('.text-label').prepend('<span class="alert-picto"></span>');
            }
        })

        /**
         * Managment of main navigation form
         */
        if ($('.navbar-form').exists()) {
            var $form   = $('.navbar-form'),
                $btn    = $('.btn.switch-type', $form),
                $input  = $('.form-control', $form);

            // Display form on btn click and change button type to submit type
            $btn.on('click', function(){
                if ($btn.attr('type') == 'button') {
                    $btn.attr('type', 'submit');
                    $form.addClass('active');
                    $input.focus();
                    return false;
                }
            });

            // Hide form on click outside them
            $('html').on('click', function(){
                $btn.attr('type', 'button');
                $form.removeClass('active');
                $input.blur().val('');
            });

            // Prevent hide form if click is on form area
            $form.on('click', function(e){
                e.stopPropagation();
            });
        }

        if ($('.form-control').exists()) {
            $('.form-control').placeholder();
        }

        if ($('.estimate-page').exists()) {
            $('input').iCheck();
        }

        /**
         * Initialization of dropdowns comportment
         */
        var $currentDropdown = null,
            $currentOpenDropdown = null;
        function initDropdowns() {
            initDropdownMenus();

            $('body')
                .on('click', '[data-toggle=dropdown]', function (event) {

                    var dataHref = $(this).data('href');

                    if (typeof dataHref !== "undefined") {
                        window.location = dataHref;
                    } else {
                        //if ($(this).parent().hasClass('open') && $(this).is(event.target)) { window.location = event.target; return false; }
                    }
                })
                .on('mouseenter', '.dropdown', function (e) {
                    var $this = $(this);

                    $currentDropdown = $this;

                    setTimeout(function(){

                        if ($this == $currentDropdown) {
                            hideCurrentDropdown();
                            $this.addClass('open');
                            $currentOpenDropdown = $this;
                        }

                    }, 150);

                })
                .on('mouseleave', '.dropdown', function (e) {
                    $currentDropdown = null;

                    setTimeout(function() {
                        if ($currentDropdown === null) {
                            hideCurrentDropdown();
                        }

                    }, 150);
                });
        }

        /**
         * Initialization of dropdown menus comportment
         */
        function initDropdownMenus() {
            $('#main-header > nav').on('mouseenter mouseleave', '.dropdown', function () {
                var elm = $('.dropdown-menu', $(this));
                var l = $(this).position().left;
                var w = elm.innerWidth();
                var docW = $('#main-header > nav').innerWidth();

                var isEntirelyVisible = (l + w <= docW);

                if (!isEntirelyVisible) {
                    $('.dropdown-menu', $(this)).addClass('dropdown-menu-right');
                } else {
                    $('.dropdown-menu', $(this)).removeClass('dropdown-menu-right');
                }
            });
        }

        /**
         * Hide current dropdown menu on mouseleave
         */
        function hideCurrentDropdown() {
            if ($currentOpenDropdown !== null) {
                $currentOpenDropdown.removeClass('open');
            }
        }

        $(".navbar-toggle").on('click', function() {
            if (window.matchMedia("(max-width: 768px)").matches) {
                /*$('.dropdown a', '.navbar-nav').removeAttr('data-toggle');
                $('.dropdown', '.navbar-nav').addClass('open');*/
            }
        });

        var displayError = function(display) {
            if (display) {
              $('#validation-error').show();
            } else {
              $('#validation-error').hide();
            }
        };

        //

        var displayMissingError = function(display, missing) {

          var parameters = 'Paramètres manquants :';

          if (missing) {

            for(i = 0; i < missing.length; i++) {
              parameters += ' ' + $('#commitment-payment-form form').find('[name="'+missing[i]+'"]').closest('.row').find('label').text() + (i+1 !== missing.length ? ',' : '');
            }
          }

          if (display) {
            $('#validation-error-missing').text(parameters);
            $('#validation-error-missing').show();
          } else {
            $('#validation-error-missing').text('');
            $('#validation-error-missing').hide();
          }
        };

        displayError(false);
        displayMissingError(false);

        $('#commitment-payment-form form a').on('click', function(ev){

            displayError(false);
            displayMissingError(false);

            var data = {
              name: $('#commitment-payment-form form').find('[name="name"]').val(),
              email: $('#commitment-payment-form form').find('[name="email"]').val(),
              reference: $('#commitment-payment-form form').find('[name="reference"]').val(),
              amount: $('#commitment-payment-form form').find('[name="amount"]').val(),
              quittance: $('#commitment-payment-form form').find('[name="quittance"]').val()
            };

            $.ajax({
                method: 'POST',
                url: '/subsciption/commitment/part/pay',
                data: data,
                success: function(data, textStatus, jqXHR){

                    if(textStatus == 'success' && data && data.status === 'success'){
                        window.location.replace(data.redirect);
                    }else{
                        displayError(true);
                    }
                }
            }).fail(function(data, textStatus, jqXHR){

                var data = $.parseJSON(data.responseText);
                var missing = data['missing'] != null ? data.missing : '';
                if (missing) {
                  displayMissingError(true, missing);
                } else {
                  displayError(true);
                }
            })

            ev.preventDefault();
        });

        /* Articles 6 by 6 display */

        var seeMoreGroup = 0;

        $('#load-btn').on('click', function(){

            seeMoreGroup++;

            var selector = '.article.see-more-' + seeMoreGroup;
            $('.content-wrapper').find(selector).removeClass('hidden');

            $('html, body').animate({
                scrollTop: $(selector).offset().top
            }, 382);
        });

        /* change all "," chars to "." */
        $('#amount').on('keyup', function(ev){
            $('#amount').val($('#amount').val().replace(/\,/g, "."));
        })
		
		  
  /*--------------RGPD cookies-------------------*/
	$('.gdpr.gdpr-overlay').after('<div style="" class="gdpr cc-revoke  cc-bottom cc-animate"><span>Cookies: Gérer le consentement</span></div>');
	$('.gdpr.gdpr-privacy-bar .gdpr-buttons .gdpr-preferences').text('Selectionner ses préférences');
	$('.gdpr.gdpr-privacy-bar .gdpr-buttons .gdpr-agreement').text('Refuser tout');
	$('.gdpr.gdpr-privacy-bar .gdpr-buttons').append('<button id="gdpr-accept-all" class="gdpr-accept-all" type="button">Accepter tout</button>');
	$('#gdpr-accept-all').on('click', function(){
		$('input[name="approved_cookies[]"]').each(function(){$(this).prop('checked','checked').trigger('change')});
		$('form.gdpr-privacy-preferences-frm').submit();
	});
	$('.gdpr.cc-revoke, #show-modal-cookies').on('click', function(){
		$('.gdpr .gdpr-buttons .gdpr-preferences').trigger('click');
	});
	
	$('.gdpr-service-header').on('click', function() {
		var item = $(this).next();
		if (item.hasClass("gdpr-service-hidden")) {
			$(this).addClass("gdpr-service-open");
			item.removeClass("gdpr-service-hidden")
		} else {
			$(this).removeClass("gdpr-service-open");
			item.addClass("gdpr-service-hidden")
		}
	});

    });

    /**
     * Jquery function to check if an element exists
     * @returns {boolean}
     */
    jQuery.fn.exists = function(){
        return this.length > 0;
    };

}(window.jQuery, window, document));